module.exports = __webpack_public_path__ + "static/media/1889(2).36a21523.jpg";